import requestService from "./request";

let getMultipleHotelPhotosService = function(options, callback) {
	var options = {
		url:window.appConfig.gatewayUrl + '/apiV1/hotel/getMultipleHotelPhotos',
		dataType: 'jsonp',
		data:{
			ids:options.hotels
		}
	};

	requestService(options,{
		success:function(response) {
			if(response.success && response.data) {
				callback && callback.success ? callback.success(response.data) : null;
			} else {
				callback && callback.error ? callback.error() : null;
			}
		},
		error:function() {
			callback && callback.error ? callback.error() : null;
		}
	});
};

export default getMultipleHotelPhotosService;

